import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
              关于我们
            </h2>
          </div>

          <div className="space-y-4 mb-10">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              {aboutData.content}
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              {aboutData.vision}
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {aboutData.stats.map((stat) => (
              <div
                key={stat.label}
                className="flex flex-col items-center p-4 bg-background-50 rounded-lg border border-background-200/60"
              >
                <span className="text-2xl md:text-3xl font-black font-heading text-primary-500">
                  {stat.value}
                </span>
                <span className="text-xs text-foreground-500 mt-1">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}